/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guides_Level_LabelInputs */

const en_guides_level_label = /** @type {(inputs: Guides_Level_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Level`)
};

const ko_guides_level_label = /** @type {(inputs: Guides_Level_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`난이도`)
};

const ja_guides_level_label = /** @type {(inputs: Guides_Level_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`難易度`)
};

/**
* | output |
* | --- |
* | "Level" |
*
* @param {Guides_Level_LabelInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guides_level_label = /** @type {((inputs?: Guides_Level_LabelInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guides_Level_LabelInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guides_level_label(inputs)
	if (locale === "ko") return ko_guides_level_label(inputs)
	return ja_guides_level_label(inputs)
});